import React from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {list} from "../../../utils/array";
import DataGrid from 'src/components/form/SelectorGrid/DataGrid';
import { loadComponent } from 'src/utils/components';

class QuizAnswerVoteLeaderboardComp extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        const {view, componentConfig, selection, isLoading} = this.props;
        const props = {componentConfig, loading: isLoading, pageSize: 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
    
        const filter = list(this.props.filter, { field: "quizanswer.quiz_id", value: this.props.quiz_id });

        let questions = this.props.questions?.items || [];
        if (!questions.length) return null;

        let columns = questions.reduce((columns, poll) => (poll.type_value + "" === "5" ? { ...columns } : {
            ...columns, ["quizanswer.poll_" + poll.id]: {
                props: {
                    width: questions.length > 1 ? questions.length : 10,
                    header: poll.title,
                    formatter: ({ value, row }) => {
                        switch (poll.type_value + "") {
                            case "6":
                                if (Array.isArray(value)) {
                                    return value.map((value, idx) => <Item
                                        key={idx} {...(value instanceof Object ? (value || {}) : { value })} />);
                                } else {
                                    return <a href={value} target="_blank">{value}</a>;
                                }
                            default:
                                return value || "";
                        }
                    }
                }
            }
        }), {
            // "id": {
            //     props: {
            //         width: 1,
            //         header: "Kód",
            //         order: "ASC",
            //         sortable: true,
            //         filterable: true,
            //     }
            // },
            "score": {
                props: {
                    width: 1,
                    header: "Pontszámok",
                    order: "DESC"
                }
            }
        }
        );
        

        return (
            <div className="row form-row">
                <div className="col-sm-12">
                    <div className="form-group">
                        {this.props.label !== false && <label htmlFor={this.props.name} className="control-label" >{this.props.label}</label>}
                        <DataGrid
                            ref={(list) => this.list = list}
                            component="QuizAnswerVote"
                            filter={filter}
                            groupBy={{
                                by: "quizanswer",
                                fields:{
                                    score: {
                                        type: "SUM"
                                    }
                                }
                            }}
                            fields={columns}
                        />
                    </div>
                </div>
            </div>
            // <SelectorGrid
            //     ref={(el) => this.list = el}
            //     gridid={this.props.gridid !== undefined ? this.props.gridid : "QuizAnswerVoteList"}
            //     {...props}
            //     columns={{
            //         [componentConfig.idfield]: {header: "Kód", sortable, filterable},
            //         "title": {header: 'Név', width: 12, sortable, filterable},
            //     }}
            //     orderBy={{field: componentConfig.idfield, direction: "DESC"}}
            //     selection={selection}
            //     onSelectionChange={(selection) => this.props.loadForm(selection.value)}
            // />
        );
    }
}


export default class QuizAnswerVoteLeaderboard extends React.Component {

    componentDidMount() {
        this.loadPolls();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.quiz_id !== prevProps.quiz_id) {
            this.loadPolls();
        }
    }

    loadPolls = () => {
        this.pollRequest && this.pollRequest.abort();
        this.pollRequest = loadComponent("componentlist", {
            component: "Poll",
            filter: { field: "quiz", value: this.props.quiz_id },
            itemsperpage: 0
        });
        this.pollRequest.then((data) => {
            this.setState({ data });
        })
    }

    render() {
        return (
            <QuizAnswerVoteLeaderboardComp {...this.props} questions={this.state?.data || {}} />
        );
    }
}